module.exports = __webpack_public_path__ + "static/media/short-of-breath.6a1e68bc.svg";